module.exports = __webpack_public_path__ + "img/logo-footer.c2973cf6.png";